<template>
    <div class="box-card"style="padding:10px;background-color: #fff">
      <div style="display: flex;justify-content: space-between;align-items: center">
        <div style="width: 83%">
          <el-input prefix-icon="iconfont el-icon-search" v-model="searchStr"
                    placeholder="输入商品名称" size="mini" class="inputSty" style="background:#E8E8E8;border-radius: 2px;outline: medium">
          </el-input>
        </div>

         <button type="primary" size="mini" @click="selectD()" style="background-color: #ff9901;border: 1px solid #ff9901;color: #fff;border-radius: 4px">搜索</button>

      </div>
      <div class="l" v-for="item in ls" style="display: flex;">
        <div class="grid-content bg-purple" style="flex-shrink: 0">
          <img src="./../../assets/images/chu.png" style="width: 27px;height: 27px;">
        </div>
        <div class="grid-content bg-purple-light" style="flex-grow: 1;border-bottom: 1px solid #e8e8e8;padding-bottom: 10px">
          <div class="lis">
            <p style="color: #4B616C">{{item.goods_name}}</p>
            <p class="s2">{{item.approval_number}}</p>
            <p class="s2">生产厂家：{{item.manufacturer}}</p>
            <div  style="display: flex;justify-content: space-between">
                <div style="font-size: 13px;color: #FF9901;">
                  总库存：{{item.total_stock}}
                </div>
                <div  style="font-size: 13px;color: #FF9901;">
                  在途库存：{{item.delivery_stock}}
                </div>
                <div   style="font-size: 13px;color: #FF9901;">
                  实际库存：{{item.actual_stock}}
                </div>
            </div>
          </div>
        </div>

      </div>

    </div>
</template>
<script>
import http from '../../APIService/http'
import navTars from "./navTars";

export default {
  name: "login1",
  data(){
    return{
      navs:'商品库存查询',
      searchStr:'',
      ls: [],
      offset: 0,
      tenant_id:'1472813523',
    }
  },
  components:{
    navTars
  },
  methods:{
    selectD(){
       let forms={
         tenant_id:this.tenant_id,
         offset:this.offset,
         searchStr:this.searchStr
       }
      let that = this
       http.post('/wapi/gkGetFeedback/GkCommodityInventoryEnquiry',forms).then(function (res){
         that.ls=res.data.data
         console.log(that.ls)
       })


    }
  },
  created() {
    this.selectD()
  }
}
</script>

<style lang="scss" scoped>
    .inputSty /deep/ span.el-input__prefix{
    left: 90px;

  }
  .inputSty /deep/ .el-input__inner{
    background: #f3f0f0;
    color: black;
    text-align: center;
  }
  .el-card{
    border: none;
  }
  .el-card__body {
    padding: 10px;
  }
  .l{
    margin-top: 10px;
  }
  .lis{
    margin-top: -10px;
    margin-left: 10px;
    font-size: 15px;
  }

  .s2{
    color: #b9afaf;
  }
  .s2{
    margin-top: -5px;
    font-size: 13px;
  }
  #s3,#s4{
    margin-left: 10px;
  }
  input::-webkit-input-placeholder {
    /* placeholder颜色  */
    color: #7A797B;
    /* placeholder字体大小  */
    font-size: 12px;
    /*取消input边框*/
    outline:medium  }
  .el-input:focus-within {
    outline: none
  }
</style>



// WEBPACK FOOTER //
// src/pages/gkReport/Inventory.vue